import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormValues, getFormSyncErrors, change } from 'redux-form';
import { flattenObject, encryptData } from '../../utils/library';
import { handleError } from '../../redux/actions/common-message/message-action';
import { everificationRequest } from '../../redux/actions/common/common-action';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import { ENCRYPT_DATA_FOR_DOCUMENT_CODE } from '../../utils/constants';
import './e-verify.scss';

class Everify extends React.Component {
  constructor(props) {
    super(props);
    this.state = { disabled: true, message: '', isDocExisting: false };
  }

  componentDidMount = () => {
    let { documentDetails, field, onEverificationMount } = this.props;
    let existingDoc = documentDetails.find(
      (key) => key.document_code === field.document_code && key.type === field.type
    );
    if (existingDoc) {
      this.setState({
        disabled: true,
        message: 'Your PAN is now verified!!',
        isDocExisting: true
      });
    }
    onEverificationMount(existingDoc ? true : false);
  };

  componentDidUpdate = (prevProps) => {
    if (this.state.isDocExisting) return;
    let {
      formValues,
      field: {
        everification_meta: { everification_request_field_data }
      },
      allSyncErrors
    } = this.props;
    let { formValues: prevFormValues } = prevProps;
    let disabled = null;
    everification_request_field_data &&
      Object.keys(everification_request_field_data).forEach((key) => {
        let field_name = everification_request_field_data[key];
        prevFormValues = flattenObject(prevFormValues);
        formValues = flattenObject(formValues);
        allSyncErrors = flattenObject(allSyncErrors);
        if (formValues[field_name] !== prevFormValues[field_name]) {
          if (!formValues[field_name] || allSyncErrors[field_name]) {
            disabled = true;
          } else {
            disabled = false;
          }
        }
      });
    if (disabled !== null && disabled !== this.state.disabled) this.setState({ disabled });
  };

  requestEverification = async () => {
    try {
      this.setState({ disabled: true });
      let {
        formValues,
        dispatch,
        formName,
        everificationRequest,
        onEverificationMount,
        activateLoader,
        disableLoader,
        onEverification,
        field,
        field: {
          everification_meta: {
            everification_url,
            everification_method,
            everification_request_constant_data,
            everification_request_field_data
          }
        }
      } = this.props;
      activateLoader();
      let request_data = {};
      formValues = flattenObject(formValues);
      everification_request_field_data &&
        Object.keys(everification_request_field_data).forEach((key) => {
          if (ENCRYPT_DATA_FOR_DOCUMENT_CODE.includes(field.document_code))
            request_data[key] = encryptData(formValues[everification_request_field_data[key]]);
          else request_data[key] = formValues[everification_request_field_data[key]];
        });
      everification_request_constant_data &&
        Object.keys(everification_request_constant_data).forEach((key) => {
          request_data[key] = everification_request_constant_data[key];
        });
      let resp = await everificationRequest(everification_url, everification_method, request_data);
      disableLoader();
      if (resp && resp.data && resp.data.success) {
        everification_request_field_data &&
          Object.keys(everification_request_field_data).forEach((key) => {
            let arr = everification_request_field_data[key].split('.');
            if (
              ENCRYPT_DATA_FOR_DOCUMENT_CODE.includes(field.document_code) &&
              resp.data.data.documents
            ) {
              dispatch(
                change(
                  formName,
                  everification_request_field_data[key],
                  resp.data.data.documents[arr[2]]
                )
              );
            }
          });
        this.setState({ message: 'Your PAN is now verified!!' });
        onEverification({
          everification_request_field_data,
          everification_response: resp.data.data
        });
        onEverificationMount(true);
      } else {
        this.setState({ disabled: false });
        onEverificationMount(false);
      }
    } catch (err) {
      handleError(err);
    }
  };

  render() {
    let { field } = this.props;
    return (
      <div className="e-everify-wrapper">
        <div className="e-verification-message brand-green">{this.state.message}</div>
        <button
          type="button"
          disabled={this.state.disabled}
          onClick={this.requestEverification}
          className="btn-e-verify"
          id={`btn-e-everify-${field.document_code}`}
        >
          E-Verify
        </button>
      </div>
    );
  }
}

Everify.propTypes = {
  documentDetails: PropTypes.array,
  field: PropTypes.object,
  allSyncErrors: PropTypes.object,
  formValues: PropTypes.object,
  onEverificationMount: PropTypes.func,
  dispatch: PropTypes.any,
  formName: PropTypes.any,
  everificationRequest: PropTypes.any,
  activateLoader: PropTypes.any,
  disableLoader: PropTypes.any,
  onEverification: PropTypes.any
};

function mapStateToProps(reduxState, ownProps) {
  let getAllformVal = getFormValues(ownProps.formName)(reduxState) || {};
  let allSyncErrors = getFormSyncErrors(ownProps.formName)(reduxState) || {};
  return {
    formValues: getAllformVal,
    allSyncErrors
  };
}

export default connect(mapStateToProps, {
  handleError,
  everificationRequest,
  activateLoader,
  disableLoader
})(Everify);
